import {IIdentityProvider, IMessageProvider, IProgressProvider} from "../PA.Core/PA.Core.IF.Basic";
import {ISearchRenderer, ISearchRendererOptions} from "./PA.UIM.Core.IF.Search";
import {IBusinessObject} from "../PA.Core/PA.Core.IF.BO";
import {
    IApplication,
    IApplicationModule,IApplicationSuiteAppRel, IUIFramework, IUIProfile
} from "./PA.UIM.Core.IF.Framework";
import {BehaviorSubject} from "rxjs";
import {PAdbContext} from "../PA.Core/PAdbContext";
import {IPolicyCollection} from "../PA.Core/PA.Core.IF.Policy";
import {NoteBO} from "../PA.MD.BusinessObjects/NoteBO";
import * as Rx from "rxjs";
import {IMessageBoxRenderer} from "./PA.UIM.Core.IF.MessageBox";
import {StandardSearchResults} from "./SearchUtils";


//
// -- This has to be implemented in UI5, in the Viewport Container control
export interface IPlatformViewportRenderer {

    setFocus(a: IApplicationModuleSession): void;
    renderSession(a: IApplicationModuleSession): void;
    destroySession(a: IApplicationModuleSession): void;

    setApplicationFocus(a: IApplicationSession): void;
    renderApplication(a: IApplicationSession, opts?:any): void;
    destroyApplication(a: IApplicationSession): void;

    getInFocusApplicationModuleSession(a: IApplicationSession): IApplicationModuleSession;
    getInFocusApplicationSession(): IApplicationSession;

    readonly OnApplicationChange: BehaviorSubject<{Action: string, ApplicationSession: IApplicationSession }>
    readonly OnApplicationModuleChange: BehaviorSubject<{Action: string, ApplicationModuleSession: IApplicationModuleSession }>

    destroyViewport(): void
    bIsClosed(): boolean

    readonly searchRenderer: ISearchRenderer
    readonly messageBoxRenderer: IMessageBoxRenderer
}

export interface IPlatformViewportFactory {
    createViewport(): Promise<IPlatformViewport>
}

export enum PlatformViewportEventAction {
    ApplicationSessionCreated = "ApplicationSessionCreated",
    ApplicationSessionClosed= "ApplicationSessionClosed",
    ApplicationModulesSessionAdded="ApplicationModulesSessionAdded",
    ApplicationModulesSessionRemoved="ApplicationModulesSessionRemoved",
    ApplicationModuleSesionClosed = "ApplicationModuleSessionClosed",

}

export interface IPlatformViewportEvent {
    action: PlatformViewportEventAction
    viewport?: IPlatformViewport
    appModuleSession?: IApplicationModuleSession
    appSession?: IApplicationSession
    options?: any
}

export interface IPlatformViewportCreateAppOptions {
    bDisableAutoLauch?: boolean,
    AppSuiteAppRel?: IApplicationSuiteAppRel,
    loadWithParam?: boolean
}

export interface ViewportStartupOptions {
    [id:string]: any
}

export interface IPlatformViewport {
    readonly viewportId: string
    readonly Renderer: IPlatformViewportRenderer

    readonly PlatformSession: IPlatformSession

    readonly ApplicationSessions: IApplicationSession[]
    readonly CurrentApplicationSession: IApplicationSession
    readonly OnSessionStateChange: BehaviorSubject<IPlatformViewportEvent>

    RunStartup(options?: ViewportStartupOptions): void

    CreateApplication(wbAppId: number, options?: IPlatformViewportCreateAppOptions): IApplicationSession
    CloseApplication(sessionId: number): Promise<boolean>

    Create(anExecutableId: string, options?: IUIOperationOptions): IApplicationModuleSession
    Open(anExecutableId: string, BOid: string| number, options?: IUIOperationOptions): IApplicationModuleSession
    OpenBO(anExecutableId: string, aBO: IBusinessObject, options?: IUIOperationOptions): IApplicationModuleSession

    Close(anExecutableId: string, BOid: string| number, options?: IUIOperationOptions): Promise<boolean>

    SelectOne(anExecutableId: string, options?: ISearchRendererOptions): Promise<number | string>;
    SelectMany(anExecutableId: string, options?: ISearchRendererOptions): Promise<number[] | string[]>;
    SelectNavigationList(anExecutableId: string, options?: ISearchRendererOptions): Promise<number[] | string[]>;

    FindSessionByObjectId(anExecutableId: string, id: string| number): IApplicationModuleSession
    FindSessionByBO(anExecutableId: string, aBO: IBusinessObject): IApplicationModuleSession
    FindSessionBySessionId(id: number): IApplicationModuleSession

}

export interface IUIOperationOptions {
    viewPort?: IPlatformViewport,
    viewPortId?: string,
    dbContext?: PAdbContext,
    bIsSearchSession?: boolean,
    boOptions?: {[id:string]: any},
    [id:string]: any
}

export interface IPlatformSessionOperationEvent {
    platformSession: IPlatformSession
    operationName: string
    applicationSession?: IApplicationSession
    applicationModuleSession?: IApplicationModuleSession
}

export interface IPlatformSessionPropertyChangedEvent {platformSession: IPlatformSession, propertyName: string, propertyValue: any}

export enum PlatformSessionRequestAction {
    UpdateViewportCount="UpdateViewportCount",
    OpenInNewViewport="OpenInNewViewport",
    OpenInViewport="OpenInViewport"
}

export interface IPlatformSessionRequest {
    Action:               PlatformSessionRequestAction,
    ViewportCount?:       number,
    ViewportColumnCount?: number,
    ViewportId?:          string,
    WbAppId?:             number,
    Objects?:             {ExecutableId?: string, BO?: IBusinessObject, BOid?: number}[]
}

export interface IPlatformSession {
    readonly Identity: IIdentityProvider,
    readonly ProgressProvider: IProgressProvider
    readonly MessageProvider: IMessageProvider,

    readonly bIsPlatformSessionLoaded: boolean
    readonly OnLoadComplete: Promise<void>

    readonly Framework: IUIFramework,
    readonly UIProfiles: IUIProfile[]
    CurrentUIProfile: IUIProfile


    registerViewport(viewport: IPlatformViewport): void
    unRegisterViewport(viewport: IPlatformViewport): void
    setDefaultViewport(viewport: IPlatformViewport): void
    readonly PlatformViewports: IPlatformViewport[],
    readonly DefaultPlatformViewport: IPlatformViewport,

    readonly OnPropertyChange: BehaviorSubject<IPlatformSessionPropertyChangedEvent>

    readonly OnPlatformSessionRequest: BehaviorSubject<IPlatformSessionRequest>

    readonly OnOperation: BehaviorSubject<IPlatformSessionOperationEvent>

   // CreateApplication(wbAppId: number, options?: IPlatformViewportCreateAppOptions): IApplicationSession
   // CloseApplication(sessionId: number): Promise<boolean>

    Create(anExecutableId: string, options?: IUIOperationOptions): IApplicationModuleSession
    Open(anExecutableId: string, BOid: string| number, options?: IUIOperationOptions): IApplicationModuleSession
    OpenBO(anExecutableId: string, aBO: IBusinessObject, options?: IUIOperationOptions): IApplicationModuleSession
    Close(anExecutableId: string, BOid: string| number, options?: IUIOperationOptions): Promise<boolean>

    SelectOne(anExecutableId: string, options?: ISearchRendererOptions): Promise<number | string>;
    SelectMany(anExecutableId: string, options?: ISearchRendererOptions): Promise<number[] | string[]>;
    SelectNavigationList(anExecutableId: string, options?: ISearchRendererOptions): Promise<number[] | string[]>;


}

export interface ApplicationStartupOptions {
    [id:string]: any
}

export interface IApplicationSession {
    readonly SessionId: number
    readonly Identity: IIdentityProvider
    readonly Application: IApplication

    readonly PlatformViewport: IPlatformViewport

    readonly ApplicationModuleSessions: IApplicationModuleSession[]
    readonly CurrentApplicationModuleSession: IApplicationModuleSession
    readonly OnApplicationModuleSessionsChange: BehaviorSubject<IPlatformViewportEvent>
    readonly RenderOptions:{[id:string]:any}
    readonly OnApplicationSessionPropertyChange:BehaviorSubject<any>
    setRenderOptions(opts: {[id:string]:any}):void

    hasExecutable(anExecutableId: string): boolean
    getAppModules(anExecutableId: string): IApplicationModule[]

    RunStartup(options?: ApplicationStartupOptions): Promise<void>

    Create(anExecutableId: string, options?: IUIOperationOptions): IApplicationModuleSession
    Open(anExecutableId: string, BOid: string| number, options?: IUIOperationOptions): IApplicationModuleSession
    OpenBO(anExecutableId: string, aBO: IBusinessObject, options?: IUIOperationOptions): IApplicationModuleSession
    Close(anExecutableId: string, BOid: string| number, options?: IUIOperationOptions): Promise<boolean>

    CreateModuleSession(anWbAppModuleId: number, options?: IUIOperationOptions): IApplicationModuleSession
    OpenModuleSession(anWbAppModuleId: number, BOid: string| number, options?: IUIOperationOptions): IApplicationModuleSession
    OpenBOModuleSession(anWbAppModuleId: number, aBO: IBusinessObject, options?: IUIOperationOptions): IApplicationModuleSession
    CloseModuleSession(anWbAppModuleId: number, BOid: string| number, options?: IUIOperationOptions): Promise<boolean>

    PruneSession(anAppModuleSession: IApplicationModuleSession): void


    getMRUList(): {[id:string]:string}[]
    setMRUList(options:any):void
}

export interface ApplicationModuleStartupOptions {
    bIgnoreStartupPolicy?: boolean,
    bIgnoreAutoLoad?: boolean
    [id:string]: any
}

export interface INavigationItem
{ id:string|number, id_ui: string, text:string, bo?: IBusinessObject, bExists?: boolean }

export interface IApplicationModuleSession {
    readonly SessionId: number
    readonly Identity: IIdentityProvider
    readonly ApplicationModule: IApplicationModule

    readonly PlatformViewport: IPlatformViewport
    readonly ApplicationSession: IApplicationSession

    readonly dbContext: PAdbContext
    readonly BusinessObject: IBusinessObject

    readonly ActionProgress: IProgressProvider
    readonly ActionMessages: IMessageProvider
    readonly OnActionComplete: Rx.BehaviorSubject<{Session: IApplicationModuleSession, Action: string}>
    readonly ActionStateChanged: Rx.BehaviorSubject<IApplicationModuleSession>
    readonly SessionChanged: Rx.BehaviorSubject<IApplicationModuleSession>


    RunStartup(options?: ApplicationModuleStartupOptions): void

    readonly PolicyCollection: IPolicyCollection

    isObject(id: number | string): boolean
    isBusinessObject(aBO: IBusinessObject): boolean
    SetBO(aBO: IBusinessObject): Promise<IApplicationModuleSession>

    beforeLoadNew?: (aSession:IApplicationModuleSession) => Promise<boolean>
    LoadNew(options?:any): Promise<IApplicationModuleSession>
    beforeLoad?: (aSession:IApplicationModuleSession, next: number | string) => Promise<boolean>
    LoadId(id: number | string, options?: any): Promise<IApplicationModuleSession>
    beforeSetBO?: (aSession:IApplicationModuleSession, next: IBusinessObject) => Promise<boolean>

    readonly bIsObjectLoaded: boolean

    readonly bIsSearchSession: boolean

    readonly bCreateNewVisible: boolean
    readonly bCreateNewEnabled: boolean
    CreateNew(): Promise<IApplicationModuleSession>


    readonly bCloseVisible: boolean
    readonly bCloseEnabled: boolean
    beforeClose?: (aSession:IApplicationModuleSession) => Promise<boolean>
    Close(options?: {bSkipSaveCheck?: boolean}): Promise<boolean>
    readonly bIsClosed: boolean

    readonly bSaveVisible: boolean
    readonly bSaveEnabled: boolean
    beforeSave?: (aSession:IApplicationModuleSession) => Promise<boolean>
    Save(): Promise<IApplicationModuleSession>

    readonly bDeleteVisible: boolean
    readonly bDeleteEnabled: boolean
    beforeDelete?: (aSession: IApplicationModuleSession) => Promise<boolean>
    Delete(options?: {bSkipUserCheck?: boolean}): Promise<IApplicationModuleSession>

    readonly bSearchVisible: boolean
    readonly bSearchEnabled: boolean
    Search(opts?:ISearchRendererOptions): Promise<IApplicationModuleSession>
    readonly bShowQuickSearch: boolean
    readonly sQuickSearchAdditionalApps: string[]
    readonly sQuickSearchPlacementText: string


    readonly bCopyVisible: boolean
    readonly bCopyEnabled: boolean
    beforeCopy?: (aSession: IApplicationModuleSession) => Promise<boolean>
    Copy(): Promise<IApplicationModuleSession>


    readonly bRevertChangesVisible: boolean
    readonly bRevertChangesEnabled: boolean
    RevertChanges(): Promise<IApplicationModuleSession>
    onRevertChanges?: (aSession:IApplicationModuleSession)=> Promise<IApplicationModuleSession>


    readonly bNavigationVisible: boolean
    setNavigationList(ids: number[] | string[] | StandardSearchResults[], options?: {bMerge?: boolean}): Promise<IApplicationModuleSession>
    clearNavigationList(): Promise<IApplicationModuleSession>

    readonly NavigationItems: INavigationItem[]
    readonly CurrentNavigationItem: INavigationItem

    readonly bNavigateNextEnabled: boolean
    NavigateNext(): Promise<IApplicationModuleSession>
    readonly bNavigatePreviousEnabled: boolean
    NavigatePrevious(): Promise<IApplicationModuleSession>

    NavigateTo(ids: number | string): Promise<IApplicationModuleSession>
    beforeNavigate?: (aSession:IApplicationModuleSession, next: IBusinessObject | number | string) => Promise<boolean>
    afterNavigate?: (aSession:IApplicationModuleSession) => Promise<void>


    readonly bCreateNoteVisible: boolean
    readonly bCreateNoteEnabled: boolean
    CreateNote(): Promise<NoteBO>

    readonly bReloadBOVisible: boolean
    readonly bReloadBOEnabled: boolean
    ReloadBO(): Promise<IBusinessObject>

    readonly bFileListVisible: boolean
    readonly bFileListEnabled: boolean

    readonly bIdDialogVisible: boolean
    readonly bIdDialogEnabled: boolean

}

